// extracted by mini-css-extract-plugin
module.exports = {"container":"J1Y4A","details":"_26dlT","arrow":"_1vrN0","title":"ItLGj","categoryLink":"_3LJ1D","moreButton":"_2wA5o","statistics":"_21BPD"};